<!-- kullanıcının yetkili olduğu ve yapabileceği talep türlerini ekrana basdığımız yerdir -->
  
<div class="row justify-content-lg-center">
	<div class="col col-lg-3 align-self-center" *ngFor="let card of (formCards | async)">
		<div class="kt-portlet">
		   

			<div class="kt-potlet__body">
				<div class="card-body" style="padding: 20px;">
					<div class="kt-pricing-1 kt-pricing-1--fixed">
						<div class="kt-pricing-1__items row justify-content-lg-center">
							<!-- Order listesinin itemlarını ekrana bastığmız yer -->
							<div class="kt-pricing-1__item col col-lg-12 align-self-center">
								
									<div class="kt-pricing-1__visual">
										<div class="kt-pricing-1__hexagon1"></div>
										<div class="kt-pricing-1__hexagon2"></div>
										<span class="kt-pricing-1__icon kt-font-brand"><i
												class="{{card.icon}}"></i></span>
									</div>
									<span class="kt-pricing-1__price">{{card.title | localize}}</span>
									<h2 class="kt-pricing-1__subtitle">{{card.subTitle | localize}}</h2>
									<!--<span class="kt-pricing-1__description">
										
										<span class="kt-pricing-1__description_text">{{card.description | localize}}</span>
									</span>-->
									<div class="kt-pricing-1__btn">
										<button type="button"
												class="btn btn-brand btn-pill btn-custom btn-wide btn-bold btn-upper"
												(click)="btnGoToNextStep(card.id)">
											{{card.buttonTitle | localize }}
										</button>
									</div>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
</div>
